import React, { useState, useEffect } from "react";
import "./styles/Verification.css";
import { ApiCall } from "../utility/ApiCalls";

function PdfViewer(props) {
  const [coords, setCoords] = useState("");
  const [fax, setFax] = useState();
  const [displayReadyFax, setDisplayReadyFax] = useState(false);

  async function getfaxcoordinatesApi() {
    const getfaxcoordinates = await ApiCall(
      {
        FaxFileName: `${sessionStorage.getItem("ActiveTaskID")}.pdf`,
      },
      "vcare-ui",
      "vcareui_getfaxcoordinates"
    );
    const res = getfaxcoordinates.body;
    setCoords(res);
  }

  async function getFaxfromAPI() {
    const response = await ApiCall(
      {
        taskID: sessionStorage.getItem("ActiveTaskID"),
      },
      "vcare-ui",
      "agent_gettaskdetails/getfax"
    );
    setFax(response.body.Fax_URL);
    console.log("fax");
    console.log(response.body.Fax_URL);
    if (response != undefined) {
      setDisplayReadyFax(true);
    }
    // var pdf = fax.body.Fax_URL;
  }

  useEffect(() => {
    getFaxfromAPI();
    getfaxcoordinatesApi();
  }, []);

  return (
    <>
      <div className="box-content box-content-document">
        <div
          id="iframe-container"
          className="documentViewer img-zoom-container"
        >
          {/* {props.highlighterFocusDiv ? (
            <>focused right new</>
          ) : (
            <>not focused right new</>
          )} */}

          <div>
            {coords ? (
              <>
                {coords.map((val, i) => (
                  <>
                    <div
                      className="highlighterFocusDiv"
                      style={{
                        top: `${Object.entries(val).map(
                          ([key, value]) => value.top
                        )}px`,
                        left: `${Object.entries(val).map(
                          ([key, value]) => value.left
                        )}px`,
                        width: `${Object.entries(val).map(
                          ([key, value]) => value.width
                        )}px`,
                        height: `${Object.entries(val).map(
                          ([key, value]) => value.height
                        )}px`,
                      }}
                    >
                    </div>
                  </>
                ))}
              </>
            ) : (
              ""
            )}  
          </div>

          <img src="img/pdf-img.png" className="documentFramePageImg" />
          {/* <object data={`${fax}#zoom=90&toolbar=0`} className="documentFramePage" id="documentInnerImage"></object> */}

          {/* <iframe
            src={`${fax}#zoom=100&toolbar=0`}
            // src="1.pdf"
            contentType="application/pdf"
            className="documentFrame"
            id="myimage"
          ></iframe> */}
        </div>
      </div>
    </>
  );
}

export default PdfViewer;
